module.exports = __webpack_public_path__ + "static/erosion_control_yard_inprogress-0b5bde4a01d664f2aa123d3b665185db.jpg";